import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { FeatureFlags } from '~/modules/feature_flags';
import { GA4ContentClickEvent, GTMBaseEvent, GtmEventType } from './gtmEventType';

const ELEMENT_TYPE = 'aiOverviewFeedback';

const CLICK_TEXT_BY_RATING: Record<string, string> = {
    positive: 'helpful',
    negative: 'unhelpful',
};

export class GtmAiOverviewFeedbackClickType extends GtmEventType {
    canHandle(event: GTMBaseEvent): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_CLICK &&
            event.elementType === ELEMENT_TYPE &&
            FeatureFlags.FF_ACE_ENABLE_AI_LISTINGS_SUMMARY_ANALYTICS_EVENTS
        );
    }

    override getBody(event: GTMBaseEvent): GA4ContentClickEvent {
        const rating = typeof event.rating === 'string' ? event.rating : '';
        return {
            event: 'custEv_contentClick',
            element_type: 'button',
            element_title: 'Was this helpful?',
            click_text: CLICK_TEXT_BY_RATING[rating] ?? '',
            content_category: 'AI Search Summary',
        };
    }
}
